import { Alert, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import { getVisibleOverlayTopPx, startViewportInteractionTracking } from "../../_helpers/viewportOverlay.helper";

startViewportInteractionTracking();

export default function CenteredAlert(params:
    {
        open: boolean,
        alertText: string,
        severity: "success" | "info" | "warning" | "error",
        borderColor?: string,
        onClose: () => void;
    }) {

    const [topPx, setTopPx] = useState(120);

    useEffect(() => {
        if (!params.open) return;
        // Place near last click so it stays in the parent viewport when embedded in a tall iframe.
        setTopPx(getVisibleOverlayTopPx(72));
    }, [params.open, params.alertText]);

    return (
        <Snackbar
            sx={{
                top: `${topPx}px !important`,
                left: "50%",
                right: "auto",
                bottom: "auto",
                transform: "translateX(-50%)",
                height: "auto",
            }}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={params.open}
            autoHideDuration={5000}
            onClose={params.onClose}
        >
            <Alert onClose={params.onClose} severity={params.severity} sx={{ width: "min(500px, calc(100vw - 24px))", border: `2px solid ${params.borderColor}` }}>
                {params.alertText}
            </Alert>
        </Snackbar>
    );
};
